module.exports = __webpack_public_path__ + "img/hong-kong-flag.51279227.jpg";